const STAND_ADMIN_ERROR_KEY = {
    no_election_session_id: 'no_election_session_id',
    unauthorized: 'unauthorized',
    unauthorized_person: 'unauthorized_person',
    stand_admin_company_id_not_found: 'stand_admin_company_id_not_found',
    missing_params: 'missing_params',
    stand_admin_company_id_mismatch: 'stand_admin_company_id_mismatch',
    authentication_failed: 'authentication_failed',
    internal_server_error: 'internal_server_error',
} as const;

export { STAND_ADMIN_ERROR_KEY };
